module.exports = __webpack_public_path__ + "static/media/seedoflife_black.cefb239c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/seedoflife_black.png
// module id = 236
// module chunks = 0